import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Select} from '../../system/select';
import React from 'react';
import {Premium} from '../dashboard/Premium';
import {PastDueHandling} from './PastDueHandling';

export const BROPlan = ({}) => {
  return (
    <>
      <h4>BRO plan</h4>
      <hr />

      <Row className={'p-2'}>
        <Col sm={'6'}>
          {' '}
          <Premium />
        </Col>
      </Row>
    </>
  );
};
